export default __webpack_public_path__ + "static/media/section24.d11eade3.svg";